import React from 'react';
import lock from './images/lock.png';

const NoPermission: React.FC = () => {  
    return (
        <div style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'calc(100vh - 120px)',
        }}>
            <img src={lock} width={180} alt=""/>
            {/* <Lock style={{fontSize: 100, fontWeight: 'bold'}}/> */}
            <span style={{
                fontSize: 24,
                marginTop: 18,
            }}>Você não tem permissão para acessar essa pagina.</span>
        </div>
    )
}
export default NoPermission;
